import { useState } from 'react';
import Form, { InputType } from '../../lib/Formik';
import {
    ONE_SPECIAL_CHARACTER,
    PasswordGuidelines,
    UPPER_CASE_LOWER_CASE,
    WHITESPACE,
} from '../../lib/PasswordGuidelines';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import * as yup from 'yup';
import { OTP_ACTIONS } from '../../utils/constants';
import { connect } from 'react-redux';
import { onResetPassword } from '../../redux-store/actions/login';
import { ForgotPasswordPayload } from '../../redux-store/types/login';
import { NoteModals } from '../../lib/NoteModals';
const { resetPassword, setPassword, common, dashboard, passwordGuidelines } = en;

interface ForgotPasswordProps {
    newPassword: string;
    confirmPassword: string;
}

const formFields: Partial<InputType>[] = [
    {
        label: setPassword.setinput,
        name: 'newPassword',
        type: 'password',
    },
    {
        label: setPassword.confirmPassword,
        name: 'confirmPassword',
        type: 'password',
    },
    {
        component: PasswordGuidelines,
        name: 'newPassword',
    },
];

const validationSchema = yup.object({
    newPassword: yup
        .string()
        .required(common.errors.password.setPassword)
        .min(8, passwordGuidelines.one)
        .test(
            passwordGuidelines.one,
            passwordGuidelines.one,
            (value = '') => !WHITESPACE.test(value),
        )
        .matches(UPPER_CASE_LOWER_CASE, passwordGuidelines.two)
        .matches(ONE_SPECIAL_CHARACTER, passwordGuidelines.three),
    confirmPassword: yup.string().required(common.errors.password.confirmPasswordRequired),
});

const initialValues: ForgotPasswordProps = {
    newPassword: '',
    confirmPassword: '',
};

function ResetPassword(props: any) {
    const { pan: userId, pekrn, reqId, data } = props.location.state || {};
    const [showDialog, setDialog] = useState<boolean>(false);
    const validate = (values: ForgotPasswordProps) => {
        if (values.newPassword !== values.confirmPassword) {
            return {
                confirmPassword: common.errors.password.confirmPasswordError,
            };
        }
    };

    const onSubmit = async (
        values: ForgotPasswordProps,
        action: FormikHelpers<ForgotPasswordProps>,
    ) => {
        action.setSubmitting(true);
        const reqBody: ForgotPasswordPayload = {
            userId,
            newPassword: values.newPassword,
            action: OTP_ACTIONS.forgot_password,
        };
        try {
            let res = await props.onResetPassword(reqBody);
            setDialog(true);
            action.setSubmitting(false);
        } catch (err: any) {
            alert(err.message);
        }
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validate,
    });

    return (
        <div className="signup-padding">
            <h2 className="text-center">{resetPassword.heading}</h2>
            <Form ui={formFields} submitButtonLabel={resetPassword.reset} formik={formik} />
            <NoteModals
                showModal={showDialog}
                heading={dashboard.Success.success}
                info={dashboard.noteModals.changePassword}
                proceedBtn={'Okay'}
                onProceed={() => props.history.push('/investor/signin')}
            />
        </div>
    );
}

export default connect(null, { onResetPassword })(ResetPassword);
